import { MenuItem, Select as MuiSelect } from '@mui/material';
import { type Props } from './types.ts';

export const Select = ({ native, options, ...rest }: Props) => (
  <MuiSelect native={native} {...rest}>
    {options.map(([key, text]) =>
      native ? (
        <option key={key} value={key}>
          {text}
        </option>
      ) : (
        <MenuItem key={key} value={key}>
          {text}
        </MenuItem>
      ),
    )}
  </MuiSelect>
);
